<template>
    <nuxt-link
        class="button"
        :class="[blok.Style, { 'hidden-mobile': blok.HiddenMobile }]"
        :style="`
       --hover-color: ${blok.HoverColor.color};
       --hover-color-text: ${blok.HoverColorText.color};
       background-color: ${blok.BackgroundColor.color};
       font-size: ${blok.FontSize}px;
       padding-left: ${blok.PaddingX};
       padding-right: ${blok.PaddingX};
       padding-top: ${blok.PaddingY};
       padding-bottom: ${blok.PaddingY};
       border-width: ${blok.BorderWidth ? `${blok.BorderWidth}px` : '1px'};
       border-color: ${blok.BorderColor.color};
       ${blok.FontWeight ? 'font-weight: ' + blok.FontWeight : ''};
       color: ${blok.TextColor.color}`"
        :to="url"
        external
    >
        <NuxtIcon name="ri:arrow-right-s-line" />
        <span>{{ blok.Text }}</span>
    </nuxt-link>
</template>

<script setup lang="ts">
import type { IL4Button } from '~/types/components/L4Button';

const { blok } = defineProps<{ blok: IL4Button }>();
const localePath = useLocalePath();
const domain = useRuntimeConfig().public.SITE_URL;
const url = blok.Link.email ? `mailto:${blok.Link.email}` : getL4InternalLink(blok.Link);
</script>

<style scoped lang="postcss">
.button {
    @apply flex min-w-[192px] leading-[17px] items-center justify-center self-center w-fit h-fit rounded-lg box-border border text-[white] bg-[#f98f43] cursor-pointer text-xl px-16 py-3 border-solid border-[#f98f43];
    transition:
        color 0.15s ease-in-out,
        background-color 0.15s ease-in-out,
        border-color 0.15s ease-in-out,
        box-shadow 0.15s ease-in-out;

    &:hover {
        @apply text-[color:var(--hover-color-text)] bg-[color:var(--hover-color)] !important;
    }

    .iconify {
        @apply mr-2.5;
    }
}
</style>
